import { useEffect, useState } from "react";

export default function PageLoader() {
  const [show, setShow] = useState(true);
  const [hiding, setHiding] = useState(false);

  useEffect(() => {
    const minMs = 1300;
    const maxMs = 2600;
    const start = performance.now();
    let t1, t2;

    const begin = () => {
      const elapsed = performance.now() - start;
      const remaining = Math.max(0, minMs - elapsed);
      t1 = setTimeout(() => setHiding(true), remaining);
      t2 = setTimeout(() => setShow(false), remaining + 700);
    };

    if (document.readyState === "complete") {
      begin();
    } else {
      window.addEventListener("load", begin, { once: true });
      t1 = setTimeout(() => { setHiding(true); t2 = setTimeout(() => setShow(false), 700); }, maxMs);
    }

    return () => {
      clearTimeout(t1); clearTimeout(t2);
      window.removeEventListener("load", begin);
    };
  }, []);

  if (!show) return null;

  return (
    <div
      className={`fixed inset-0 z-[150] bg-navy flex items-center justify-center overflow-hidden transition-opacity duration-700 ${hiding ? "opacity-0 pointer-events-none" : "opacity-100"}`}
      data-testid="page-loader"
      aria-hidden={hiding}
    >
      <div className="absolute inset-0 pattern-girih opacity-40" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(197,160,89,0.18)_0%,rgba(14,42,71,0)_60%)]" />

      <div className="relative flex flex-col items-center">
        {/* Expanding rings */}
        <div className="relative w-44 h-44 flex items-center justify-center">
          <span className="absolute inset-0 rounded-full border border-gold/50 loader-ring" />
          <span className="absolute inset-0 rounded-full border border-gold/35 loader-ring" style={{ animationDelay: "0.6s" }} />
          <span className="absolute inset-0 rounded-full border border-gold/20 loader-ring" style={{ animationDelay: "1.2s" }} />

          {/* Rotating girih ring */}
          <span className="absolute -inset-3 rounded-full border-2 border-dashed border-gold/40 loader-rotate" />
          <span className="absolute -inset-7 rounded-full border border-gold/20 loader-rotate" style={{ animationDirection: "reverse", animationDuration: "10s" }} />

          {/* Logo */}
          <img
            src="/fic-logo.png"
            alt="Flint Islamic Center"
            className="relative w-28 h-28 object-contain bg-cream rounded-full p-2 shadow-2xl shadow-gold/30 loader-breathe"
          />
        </div>

        {/* Shimmer tagline */}
        <div className="mt-8 text-[11px] uppercase tracking-[0.5em] loader-shimmer font-semibold">
          Flint Islamic Center
        </div>
        <div className="mt-3 text-[10px] tracking-[0.35em] text-gold/70 uppercase">
          Unity · Compassion · Community
        </div>

        {/* Progress bar */}
        <div className="mt-8 w-52 h-[2px] bg-cream/10 rounded-full overflow-hidden">
          <div className="h-full bg-gradient-to-r from-transparent via-gold to-transparent loader-bar" />
        </div>

        {/* Arabic greeting */}
        <div className="mt-6 font-serif text-lg text-cream/75" lang="ar">بسم الله</div>
      </div>
    </div>
  );
}
